import Autocomplete from "@mui/material/Autocomplete";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from "@mui/material/TextField";
import axios from "axios";
import { useEffect, useState } from "react";
import { MdArrowBack, MdEdit, MdPerson } from "react-icons/md";
import ImageUploading from "react-images-uploading";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import { web_url } from "../../constant";

const url = "http://localhost:8080/api/";
function EditProfile({ t, language }) {
    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });
    const navigate = useNavigate();

    const [details, setDetails] = useState(() => {
        const nameStudent = localStorage.getItem('name');
        const personalInterestsStudent = localStorage.getItem('personalInterests') ? (JSON.parse(localStorage.getItem('personalInterests')) || {}) : {};
        return {
            namePerm: nameStudent,
            name: nameStudent,
            hobbies: personalInterestsStudent.hobbies ? personalInterestsStudent.hobbies : [],
            hobbiesPerm: personalInterestsStudent.hobbies ? personalInterestsStudent.hobbies : [],
            actors: personalInterestsStudent.actors ? personalInterestsStudent.actors : [],
            actorsPerm: personalInterestsStudent.actors ? personalInterestsStudent.actors : [],
            sports: personalInterestsStudent.sports ? personalInterestsStudent.sports : [],
            sportsPerm: personalInterestsStudent.sports ? personalInterestsStudent.sports : [],
            movies: personalInterestsStudent.movies ? personalInterestsStudent.movies : [],
            moviesPerm: personalInterestsStudent.movies ? personalInterestsStudent.movies : [],
            personalInterests: personalInterestsStudent,
            personalInterestsPerm: personalInterestsStudent
        }
    })

    const options = [
        { label: 'Favourite actors', value: 'Actors' },
        { label: 'Favourite hobbies', value: 'Hobbies' },
        { label: 'Favourite movies', value: 'Movies' },
        { label: 'Favourite sports', value: 'Sports' },
    ];

    const [optionsVisible, setOptionsVisible] = useState({
        Actors: false,
        Quote: false,
        Movies: false,
        Sports: false,
        Hobbies: false,
        noFavourites: false
    })

    const [selectedOptions, setSelectedOptions] = useState([]);

    // Handle selection
    const handleChange = (selected) => {
        setSelectedOptions(selected);

        const updatedVisibility = {
            Actors: selected.some(option => option.value === 'Actors'),
            Quote: selected.some(option => option.value === 'Quote'),
            Movies: selected.some(option => option.value === 'Movies'),
            Sports: selected.some(option => option.value === 'Sports'),
            Hobbies: selected.some(option => option.value === 'Hobbies'),
        };

        setOptionsVisible(updatedVisibility);
    };

    const [imageSrc, setImageSrc] = useState(() => {
        const image = localStorage.getItem('profilePhoto') ? localStorage.getItem('profilePhoto') : null;
        return image
    });

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open2, setOpen2] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
        if (!isXlOrLarger) {
            navigate('/mobile/student/settings')
        } else {
            navigate('/desktop/student/dashboard')
        }
    };

    const [isLoading, setIsLoading] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('image size is greater')) {
            setError(t('t174'));
        } else if (err.toLowerCase().includes('image should be a square')) {
            setError(t('t174_2'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        setOpen(false);
    };


    useEffect(() => {
        const preSelectedOptions = [];

        if (details.actors?.length > 0) {
            preSelectedOptions.push({ label: 'Favourite actors', value: 'Actors' });
        }
        if (details.hobbies?.length > 0) {
            preSelectedOptions.push({ label: 'Favourite hobbies', value: 'Hobbies' });
        }
        if (details.movies?.length > 0) {
            preSelectedOptions.push({ label: 'Favourite movies', value: 'Movies' });
        }
        if (details.sports?.length > 0) {
            preSelectedOptions.push({ label: 'Favourite sports', value: 'Sports' });
        }

        setSelectedOptions(preSelectedOptions);

        setOptionsVisible({
            Actors: details.actors?.length > 0,
            Movies: details.movies?.length > 0,
            Sports: details.sports?.length > 0,
            Hobbies: details.hobbies?.length > 0,
            noFavourites: preSelectedOptions.length === 0
        });
    }, []);

    // useEffect(() => {
    //     setDetails(prevDetails => {
    //         // Filter out empty arrays in personalInterests
    //         const filteredInterests = Object.fromEntries(
    //             Object.entries(prevDetails.personalInterests).filter(([key, value]) => value.length > 0)
    //         );

    //         return {
    //             ...prevDetails,
    //             personalInterests: filteredInterests
    //         };
    //     });
    // }, [selectedOptions])

    const handleChangeHobby = (event, newValue, reason) => {
        // Allow removing at any time
        if (reason === 'removeOption' || newValue.length <= 2) {
            setDetails((prev) => ({ ...prev, hobbies: newValue }));
        }
    };

    const handleChangeSports = (event, newValue, reason) => {
        // Allow up to 2 selections only
        if (reason === 'removeOption' || newValue.length <= 2) {
            setDetails((prev) => ({ ...prev, sports: newValue }))
        }
    };

    const handleChangeActor = (event, newValue, reason) => {
        // Allow up to 2 selections only
        if (reason === 'removeOption' || newValue.length <= 2) {
            setDetails((prev) => ({ ...prev, actors: newValue }))
        }
    };

    const handleChangeMovie = (event, newValue, reason) => {
        // Allow up to 2 selections only
        if (reason === 'removeOption' || newValue.length <= 2) {
            setDetails((prev) => ({ ...prev, movies: newValue }))
        }
    };


    const [errors, setErrors] = useState(
        {
            noName: false,
            invalidName: false,
            noInterest: false,
            noHobbies: false,
            noSports: false,
            noActors: false,
            noMovies: false
        }
    )

    const [images, setImages] = useState([]);
    const maxNumber = 2; // Allow only one image upload

    const onChange = (imageList) => {
        setImages(imageList);
        // console.log(images);

    };

    const handleContinue = () => {


        const nameRegex = /^[^\d]*$/;
        let newErrors = {};
        newErrors.noName = !details.name;

        if ((details.name) && !nameRegex.test(details.name)) {
            newErrors.invalidName = true;
        } else {
            newErrors.invalidName = false;
        }


        if ((selectedOptions.some(option => option.label === 'Favourite actors')) || (selectedOptions.some(option => option.label === 'Favourite hobbies')) ||
            (selectedOptions.some(option => option.label === 'Favourite movies')) || (selectedOptions.some(option => option.label === 'Favourite sports'))
        ) {
            newErrors.noInterest = false;
        } else {
            newErrors.noInterest = true;
        }


        if ((selectedOptions.some(option => option.label === 'Favourite actors')) && details.actors.length === 0) {
            newErrors.noActors = true
        } else {
            newErrors.noActors = false
        }

        if ((selectedOptions.some(option => option.label === 'Favourite hobbies')) && details.hobbies.length === 0) {
            newErrors.noHobbies = true
        } else {
            newErrors.noHobbies = false
        }

        if ((selectedOptions.some(option => option.label === 'Favourite movies')) && details.movies.length === 0) {
            newErrors.noMovies = true
        } else {
            newErrors.noMovies = false
        }

        if ((selectedOptions.some(option => option.label === 'Favourite sports')) && details.sports.length === 0) {
            newErrors.noSports = true
        } else {
            newErrors.noSports = false
        }

        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }


        // console.log(details);

        handleClickOpen(true);
    }

    const checkImageDimensions = (file) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = function () {
                if (img.width !== img.height) {
                    handleClickOpenError("Image should be a square (width must be equal to height).");
                } else {
                    resolve();
                }
            };
            img.onerror = () => reject("Error loading image.");
        });
    };

    const handleUpdate = async () => {
        const personalInterests = () => {
            const newPersonalInterests = {};

            if ((selectedOptions.some(option => option.label === 'Favourite sports')) && details.sports && details.sports.length > 0) {
                newPersonalInterests.sports = details.sports;
            }

            if ((selectedOptions.some(option => option.label === 'Favourite hobbies')) && details.hobbies && details.hobbies.length > 0) {
                newPersonalInterests.hobbies = details.hobbies;
            }

            if ((selectedOptions.some(option => option.label === 'Favourite actors')) && details.actors && details.actors.length > 0) {
                newPersonalInterests.actors = details.actors;
            }

            if ((selectedOptions.some(option => option.label === 'Favourite movies')) && details.movies && details.movies.length > 0) {
                newPersonalInterests.movies = details.movies;
            }

            return newPersonalInterests;
        };


        const arePersonalInterestsEqual = (obj1, obj2) => {
            const keys1 = Object.keys(obj1);
            const keys2 = Object.keys(obj2);

            // First check if both objects have the same keys
            if (keys1.length !== keys2.length) return false;

            // Now check if arrays inside the objects are equal
            return keys1.every(key => {
                // Check if both objects have the key and the arrays are identical
                if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
                    return obj1[key].length === obj2[key].length &&
                        obj1[key].every((value, index) => value === obj2[key][index]);
                }
                return false; // return false if it's not an array or doesn't match
            });
        };

        if (images.length > 0 && images[0].file) {
            const file = images[0].file;
            const fileSizeInMB = file.size / (1024 * 1024);
            console.log("File size: ", fileSizeInMB, "MB");
            if (fileSizeInMB > 1) {
                console.log("done");
                handleClickOpenError("Image size is greater than the expected size. Image size should be less than 1 MB")
                return;
            }
            try {
                // Wait for the image check to complete
                await checkImageDimensions(file);
            } catch (error) {
                handleClickOpenError(error);
                return;
            }
        }


        if ((details.namePerm !== details.name || (arePersonalInterestsEqual(personalInterests(), details.personalInterestsPerm) === false)) && images.length > 0) {
            const file = images[0].file;
            const detailsNow = {
                userFullName: details.name,
                personalInterests: personalInterests()
            };

            setIsLoading(true);
            const getLogDetails = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails = getLogDetails();

            const apiUrl = `${url}auth/students/${logDetails.email}`
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };
            // axios.post(apiUrl, teacher, config)
            axios.patch(`${web_url}/api/auth/students/${logDetails.email}`, detailsNow, config)
                .then((response) => {
                    console.log("updated successfully", response.data);
                    localStorage.setItem('name', response.data.userFullName);
                    localStorage.setItem('personalInterests', response.data.personalInterests);
                    const formData = new FormData();
                    formData.append('file', file);

                    const apiUrl = `${url}auth/students/${logDetails.email}/profile-photo`
                    const config = {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${logDetails.token}`,
                        },
                    };
                    // axios.post(apiUrl, teacher, config)
                    axios.patch(`${web_url}/api/auth/students/${logDetails.email}/profile-photo`, formData, config)
                        .then((response) => {
                            console.log("updated successfully", response.data);

                            setIsLoading(false);
                            setOpen(false);
                            handleClickOpen2();
                        })
                        .catch((err) => {
                            console.log(err);

                            if (err.response) {
                                if (err.response.data.error) {
                                    handleClickOpenError(err.response.data.error);
                                } else if (err.response.data.message) {
                                    handleClickOpenError(err.response.data.message);
                                } else {
                                    handleClickOpenError("An unknown error occured");
                                }

                            } else if (err.request) {
                                const errorMessage = "No response from the server. Please check your network connection.";
                            } else {
                                const errorMessage = err.message;
                            }
                            setIsLoading(false);

                        })

                })
                .catch((err) => {
                    if (err.response) {
                        if (err.response.data.error) {
                            handleClickOpenError(err.response.data.error);
                        } else if (err.response.data.message) {
                            handleClickOpenError(err.response.data.message);
                        } else {
                            handleClickOpenError("An unknown error occured");
                        }

                    } else if (err.request) {
                        const errorMessage = "No response from the server. Please check your network connection.";
                    } else {
                        const errorMessage = err.message;
                    }
                    setIsLoading(false);
                })
        } else if ((details.namePerm !== details.name || (arePersonalInterestsEqual(personalInterests(), details.personalInterestsPerm) === false)) && images.length === 0) {

            const detailsNow = {
                userFullName: details.name,
                personalInterests: personalInterests()
            };

            setIsLoading(true);
            const getLogDetails = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails = getLogDetails();

            const apiUrl = `${url}auth/students/${logDetails.email}`
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };
            // axios.post(apiUrl, teacher, config)
            axios.patch(`${web_url}/api/auth/students/${logDetails.email}`, detailsNow, config)
                .then((response) => {
                    console.log("updated successfully", response.data);
                    localStorage.setItem('name', response.data.userFullName);
                    localStorage.setItem('personalInterests', response.data.personalInterests);
                    setIsLoading(false);
                    setOpen(false);
                    handleClickOpen2();

                })
                .catch((err) => {
                    if (err.response) {
                        if (err.response.data.error) {
                            handleClickOpenError(err.response.data.error);
                        } else if (err.response.data.message) {
                            handleClickOpenError(err.response.data.message);
                        } else {
                            handleClickOpenError("An unknown error occured");
                        }

                    } else if (err.request) {
                        const errorMessage = "No response from the server. Please check your network connection.";
                    } else {
                        const errorMessage = err.message;
                    }
                    setIsLoading(false);
                })

        } else if ((details.namePerm === details.name && (arePersonalInterestsEqual(personalInterests(), details.personalInterestsPerm) === true)) && images.length > 0) {

            const file = images[0].file;
            setIsLoading(true);
            const getLogDetails = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails = getLogDetails();
            const formData = new FormData();
            formData.append('file', file);

            const apiUrl = `${url}auth/students/${logDetails.email}/profile-photo`
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };
            // axios.post(apiUrl, teacher, config)
            axios.patch(`${web_url}/api/auth/students/${logDetails.email}/profile-photo`, formData, config)
                .then((response) => {
                    console.log("updated successfully", response.data);

                    setIsLoading(false);
                    setOpen(false);
                    handleClickOpen2();
                })
                .catch((err) => {
                    console.log(err);

                    if (err.response) {
                        if (err.response.data.error) {
                            handleClickOpenError(err.response.data.error);
                        } else if (err.response.data.message) {
                            handleClickOpenError(err.response.data.message);
                        } else {
                            handleClickOpenError("An unknown error occured");
                        }

                    } else if (err.request) {
                        const errorMessage = "No response from the server. Please check your network connection.";
                    } else {
                        const errorMessage = err.message;
                    }
                    setIsLoading(false);
                })
        } else {
            setIsLoading(false);
            setOpen(false);
            handleClickOpen2();
        }
    }

    return (

        <div className="overflow-y-auto pl-[30px] pb-[150px] xl:pb-[20px] pr-[30px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[10px] 2xl:pt-[20px]">
            <div className="flex items-center justify-start mt-[20px] lg:ml-[70px]">
                <MdArrowBack size={25} className="md:hidden" onClick={() => {
                    navigate('/mobile/student/settings')
                }} />
                <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                    navigate('/mobile/student/settings')
                }} />
                <p className="text-[20px] ml-[10px] md:text-[23px] lg:text-[25px] xl:text-[19px] 2xl:text-[25px]">{t('t154')}</p>
            </div>
            <div className="flex flex-col items-center pt-[10px] md:pt-[20px] xl:pt-[0px] 2xl:pt-[0px]">
                <ImageUploading
                    value={images}
                    onChange={onChange}
                    maxNumber={maxNumber}
                    dataURLKey="data_url"
                    acceptType={["jpg", "png", "jpeg"]}
                >
                    {({ imageList, onImageUpload, isDragging, dragProps }) => (
                        <div className="upload__image-wrapper">
                            {imageList.map((image, index) => (
                                <div key={index} className="flex flex-col pt-[20px]  justify-center items-center">
                                    <div className="h-[150px] w-[150px] xl:h-[120px] xl:w-[120px] lg:h-[160px] lg:w-[160px] 2xl:h-[140px] 2xl:w-[140px] rounded-full  relative">
                                        {/* Position the MdEdit icon */}
                                        <div className="lg:h-[160px] lg:w-[160px] h-[150px] w-[150px] xl:h-[120px] xl:w-[120px] 2xl:h-[140px] 2xl:w-[140px] rounded-full overflow-hidden  relative">
                                            <img src={image.data_url} alt="Uploaded" className="h-full w-full object-cover" />
                                        </div>
                                        <MdEdit
                                            size="30px"
                                            color="#ffffff"
                                            onClick={onImageUpload}
                                            {...dragProps}
                                            className="absolute bottom-0 right-0 cursor-pointer bg-[#F2AC0E] rounded-md shadow-md"
                                        />
                                    </div>
                                    {/* <p className="font-bold text-[25px] md:text-[40px] lg:text-[50px] xl:text-[30px] text-black">
                              {details.namePerm}
                            </p>
                            <p className="font-normal text-[19px] md:text-[27px] lg:text-[35px] xl:text-[20px] text-black">
                              {details.mobile}
                            </p> */}
                                </div>
                            ))}
                            {imageList.length === 0 && (
                                <div className="flex flex-col pt-[20px] justify-center items-center">
                                    <div className="lg:h-[160px] lg:w-[160px] h-[150px] w-[150px] xl:h-[120px] xl:w-[120px] 2xl:h-[140px] 2xl:w-[140px] rounded-full  relative">
                                        {/* Position the MdEdit icon */}
                                        <div className="lg:h-[160px] lg:w-[160px] h-[150px] w-[150px] xl:h-[120px] xl:w-[120px] 2xl:h-[140px] 2xl:w-[140px]  rounded-full overflow-hidden  relative">
                                            <img src={imageSrc} alt="Uploaded" className="h-full w-full object-contain bg-black" />
                                        </div>
                                        <MdEdit
                                            size="30px"
                                            color="#ffffff"
                                            onClick={onImageUpload}
                                            {...dragProps}
                                            className="absolute bottom-0 right-0 cursor-pointer bg-[#F2AC0E] rounded-md shadow-md"
                                        />
                                    </div>
                                    {/* <p className="font-bold text-[25px] md:text-[40px] lg:text-[50px] xl:text-[30px] text-black">
                                        {details.namePerm}
                                    </p>
                                    <p className="font-normal text-[19px] md:text-[27px] lg:text-[35px] xl:text-[20px] text-black">
                                        {details.mobile}
                                    </p> */}
                                </div>
                            )}
                        </div>

                    )}
                </ImageUploading>
            </div>
            <div className="flex justify-center items-center mt-[15px]"><br />
                <p className="text-[14px] md:text-[17px] xl:text-[15px] 2xl:text-[16px] text-gray-500">{t('t173')}</p>
            </div>
            <div className="flex flex-col items-center justify-center">
                <div className="items-center mt-[20px] xl:mt-[10px] 2xl:mt-[30px] flex rounded-md w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdPerson size="24px" color="#8189B0" />
                    <input type="text" value={details.name} name="name" className="ml-[10px] w-full xl:w-[450px] bg-[#F1F6FB] text-[15px] md:text-[17px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t27')}
                        onChange={(e) => {
                            setDetails((prevState) => ({
                                ...prevState, name: e.target.value
                            }))
                        }}
                    />
                </div>
                <div className="flex w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] items-center justify-start">
                    {errors.noName &&
                        <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t86')}</p>
                    }

                    {errors.invalidName &&
                        <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t90')}</p>
                    }
                </div>

                <div className='items-center mt-[15px] w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] flex rounded-md bg-[#F1F6FB] h-[50px] md:h-[60px] xl:h-[50px] 2xl:h-[60px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400'>
                    <Select
                        options={options}
                        isMulti
                        value={selectedOptions}
                        onChange={handleChange}
                        placeholder={t('t40_1')}
                        menuPortalTarget={document.body}
                        className="basic-multi-select w-full h-full"
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 1000 }),
                            control: (provided, state) => ({
                                ...provided,
                                background: '#F1F6FB',
                                height: '100%', // Set height to fill the parent
                                minHeight: 'unset', // Prevents the default minHeight from overriding
                                border: 'none', // Removes react-select's default border
                                boxShadow: 'none', // Removes the default box shadow
                                padding: 0,
                                outline: state.isFocused
                                    ? '2px solid #9CA3AF' // Outline color when focused
                                    : '1px solid #9CA3AF', // Default outline color
                                outlineOffset: '-1px',
                                borderRadius: '6px', // Match parent border radius
                                transition: 'outline 0.2s ease',
                                display: 'flex', // Ensures the items are aligned properly
                            }),
                            valueContainer: (provided) => ({
                                ...provided,
                                height: '100%', // Ensures the selected items take full height
                                padding: '0 8px',
                                display: 'flex', // Ensures items are displayed in a row
                                flexWrap: 'nowrap', // Prevents wrapping of selected items
                                overflowX: 'auto', // Enables horizontal scrolling
                                gap: '4px', // Adds spacing between items
                            }),
                            placeholder: (provided) => ({
                                ...provided,
                                color: '#8189B0', // Placeholder text color
                                fontSize: language === "en" ? '0.95rem' : "0.875rem", // Font size for placeholder
                            }),
                            multiValue: (provided) => ({
                                ...provided,
                                backgroundColor: '#E5E7EB', // Background color for selected items
                                borderRadius: '4px',
                                display: 'inline-flex', // Ensures inline display
                                alignItems: 'center',
                                padding: '0 4px',
                                margin: '0', // Removes default margin
                            }),
                            multiValueLabel: (provided) => ({
                                ...provided,
                                color: '#111827', // Text color for selected items
                                fontSize: '0.875rem',
                            }),
                            multiValueRemove: (provided) => ({
                                ...provided,
                                cursor: 'pointer',
                                ':hover': {
                                    backgroundColor: '#D1D5DB', // Background color on hover
                                    color: '#111827',
                                },
                            }),
                            indicatorsContainer: (provided) => ({
                                ...provided,
                                height: '100%', // Ensures the dropdown arrow takes full height
                            }),
                        }}
                        classNamePrefix="select"
                    />
                </div>
                {errors.noInterest &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t40_6')}</p>
                }


                {
                    optionsVisible.Hobbies && <div className="mt-[15px] w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px]">
                        <>

                            <Autocomplete
                                multiple
                                freeSolo
                                id="tags-standard"
                                options={[]}
                                disableClearable
                                value={details.hobbies}
                                onChange={(event, newValue, reason) => {
                                    if (reason === 'removeOption' || newValue.length <= 2) {
                                        handleChangeHobby(event, newValue, reason);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder={t('t40_11')}
                                        label={t('t40_7')}
                                        variant="outlined"
                                        slotProps={{
                                            htmlInput: {
                                                ...params.inputProps,
                                                readOnly: details.hobbies.length >= 2,
                                            },
                                            inputLabel: {
                                                color: '#6B7280',

                                            }
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                fontFamily: 'Urbanist',
                                                backgroundColor: '#F1F6FB',
                                                borderRadius: 2,
                                                '& fieldset': { borderColor: '#9CA3AF' },
                                                '&:hover fieldset, &.Mui-focused fieldset': { borderColor: '#9CA3AF' },
                                            },
                                            '& input::placeholder': {
                                                color: '#6B7280',
                                                opacity: 1, // for consistent appearance in Firefox
                                                fontSize: {
                                                    xs: language === 'en' ? '14px' : language === "si" ? '13px' : '13px',
                                                    sm: language === 'en' ? '16px' : language === "si" ? '16px' : '16px',
                                                    md: language === 'en' ? '18px' : language === "si" ? '17px' : '17px',
                                                    lg: language === 'en' ? '16px' : language === "si" ? '17px' : '15px',
                                                    xl: language === 'en' ? '16px' : language === "si" ? '18px' : '18px'
                                                },
                                            },
                                        }}
                                    />
                                )}
                            />

                            {errors.noHobbies &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t40_2')}</p>
                            }
                        </>

                    </div>
                }

                {
                    optionsVisible.Actors && <div className="mt-[15px] w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px]">
                        <>
                            <Autocomplete
                                multiple
                                freeSolo
                                id="tags-standard"
                                options={[]}
                                disableClearable
                                value={details.actors}
                                onChange={(event, newValue, reason) => {
                                    if (reason === 'removeOption' || newValue.length <= 2) {
                                        handleChangeActor(event, newValue, reason);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder={t('t40_11')}
                                        label={t('t40_9')}
                                        variant="outlined"
                                        slotProps={{
                                            htmlInput: {
                                                ...params.inputProps,
                                                readOnly: details?.actors?.length >= 2,
                                            },
                                            inputLabel: {
                                                color: '#6B7280',
                                            }
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                fontFamily: 'Urbanist',
                                                backgroundColor: '#F1F6FB',
                                                borderRadius: 2,
                                                '& fieldset': { borderColor: '#9CA3AF' },
                                                '&:hover fieldset, &.Mui-focused fieldset': { borderColor: '#9CA3AF' },
                                            },
                                            '& input::placeholder': {
                                                color: '#6B7280',
                                                opacity: 1, // for consistent appearance in Firefox
                                                fontSize: {
                                                    xs: language === 'en' ? '14px' : language === "si" ? '13px' : '13px',
                                                    sm: language === 'en' ? '16px' : language === "si" ? '16px' : '16px',
                                                    md: language === 'en' ? '18px' : language === "si" ? '17px' : '17px',
                                                    lg: language === 'en' ? '16px' : language === "si" ? '17px' : '15px',
                                                    xl: language === 'en' ? '16px' : language === "si" ? '18px' : '18px'
                                                },
                                            },
                                        }}
                                    />
                                )}
                            />
                            {errors.noActors &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t40_5')}</p>
                            }
                        </>
                    </div>
                }

                {
                    optionsVisible.Sports && <div className="mt-[15px] w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px]">
                        <>
                            <Autocomplete
                                multiple
                                freeSolo
                                id="tags-standard"
                                options={[]}
                                disableClearable
                                value={details.sports}
                                onChange={(event, newValue, reason) => {
                                    if (reason === 'removeOption' || newValue.length <= 2) {
                                        handleChangeSports(event, newValue, reason);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder={t('t40_11')}
                                        label={t('t40_10')}
                                        variant="outlined"
                                        slotProps={{
                                            htmlInput: {
                                                ...params.inputProps,
                                                readOnly: details.sports.length >= 2,
                                            },
                                            inputLabel: {
                                                color: '#6B7280',
                                            }
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                fontFamily: 'Urbanist',
                                                backgroundColor: '#F1F6FB',
                                                borderRadius: 2,
                                                '& fieldset': { borderColor: '#9CA3AF' },
                                                '&:hover fieldset, &.Mui-focused fieldset': { borderColor: '#9CA3AF' },
                                            },
                                            '& input::placeholder': {
                                                color: '#6B7280',
                                                opacity: 1, // for consistent appearance in Firefox
                                                fontSize: {
                                                    xs: language === 'en' ? '14px' : language === "si" ? '13px' : '13px',
                                                    sm: language === 'en' ? '16px' : language === "si" ? '16px' : '16px',
                                                    md: language === 'en' ? '18px' : language === "si" ? '17px' : '17px',
                                                    lg: language === 'en' ? '16px' : language === "si" ? '17px' : '15px',
                                                    xl: language === 'en' ? '16px' : language === "si" ? '18px' : '18px'
                                                },
                                            },
                                        }}
                                    />
                                )}
                            />
                            {errors.noSports &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t40_3')}</p>
                            }
                        </>
                    </div>
                }

                {
                    optionsVisible.Movies && <div className="mt-[15px] w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px]">
                        <>
                            <Autocomplete
                                multiple
                                freeSolo
                                id="tags-standard"
                                options={[]}
                                disableClearable
                                value={details.movies}
                                onChange={(event, newValue, reason) => {
                                    if (reason === 'removeOption' || newValue.length <= 2) {
                                        handleChangeMovie(event, newValue, reason);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder={t('t40_11')}
                                        label={t('t40_8')}
                                        variant="outlined"
                                        slotProps={{
                                            htmlInput: {
                                                ...params.inputProps,
                                                readOnly: details.movies.length >= 2,
                                            },
                                            inputLabel: {
                                                color: '#6B7280',
                                            }
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                fontFamily: 'Urbanist',
                                                backgroundColor: '#F1F6FB',
                                                borderRadius: 2,
                                                '& fieldset': { borderColor: '#9CA3AF' },
                                                '&:hover fieldset, &.Mui-focused fieldset': { borderColor: '#9CA3AF' },
                                            },
                                            '& input::placeholder': {
                                                color: '#6B7280',
                                                opacity: 1,
                                                fontSize: {
                                                    xs: language === 'en' ? '14px' : language === "si" ? '13px' : '13px',
                                                    sm: language === 'en' ? '16px' : language === "si" ? '16px' : '16px',
                                                    md: language === 'en' ? '18px' : language === "si" ? '17px' : '17px',
                                                    lg: language === 'en' ? '16px' : language === "si" ? '17px' : '15px',
                                                    xl: language === 'en' ? '16px' : language === "si" ? '18px' : '18px'
                                                },
                                            },
                                        }}
                                    />
                                )}
                            />
                            {errors.noMovies &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t40_4')}</p>
                            }
                        </>
                    </div>
                }


            </div>
            <div className=" flex justify-center mt-[20px] md:mt-[20px] lg:mt-[30px] xl:mt-[10px] xl:mb-[50px] 2xl:mt-[30px] ">
                <div className="w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] flex justify-center gap-[30px]">
                    <button onClick={() => {
                        if (!isXlOrLarger) {
                            navigate('/mobile/student/settings')
                        } else {
                            navigate('/desktop/student/dashboard')
                        }
                    }} className="w-[45%] bg-[#F2AC0E] text-black px-[20px] py-[10px] md:py-[15px] 2xl:py-[15px]  rounded-md">{t('t145')}</button>
                    <button onClick={handleContinue} className="w-[45%] bg-[#F2AC0E] text-black px-[20px] py-[10px] md:py-[15px] 2xl:py-[15px] rounded-md">{t('t146')}</button>
                </div>

            </div>
            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className='flex flex-col justify-center items-center text-center'>
                            {
                                isLoading ?
                                    <div className="items-center justify-center flex">
                                        <div className='w-10 h-10 border-2 border-t-transparent border-[#F2AC0E] rounded-full animate-spin'></div>
                                    </div>
                                    : <>
                                        <div className='mt-[0px]'>{t('t166')}</div>
                                        <div className="flex justify-center item-center gap-[20px] mt-[20px]">
                                            <Button
                                                onClick={handleClose}
                                                className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                                style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                            >
                                                {t('t145')}
                                            </Button>
                                            <Button
                                                onClick={() => { handleUpdate() }}
                                                className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                                style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                            >
                                                {t('t144')}
                                            </Button>
                                        </div>
                                    </>
                            }
                        </div>
                    </DialogContent>
                </DialogContent>
            </Dialog>


            <Dialog
                open={open2}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose2(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className='flex flex-col justify-center items-center text-center'>
                            <div className='mt-[0px]'>{t('t165')}</div>
                            <div className="flex justify-center item-center gap-[20px] mt-[20px]">
                                <Button
                                    onClick={handleClose2}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t7')}
                                </Button>
                            </div>

                        </div>
                    </DialogContent>
                </DialogContent>
            </Dialog>

        </div>
    )
}

export default EditProfile;